import NextStepsStep from '../../../templates/NextStepsStep/NextStepsStep.component';
import NextStepsStepPage from './NextStepsStep.page';

export default NextStepsStepPage;

export { NextStepsStep };
